export default __webpack_public_path__ + "static/24934220-night-d0c6baa1dca2a81e3131fbbefc6590a7.ogv";